import { useQuery } from 'react-query';

import type { UserFreelancerAutoCompleteItem } from '../types';

type UseUserFreelancersAutoCompleteHandler = {
  data: Array<UserFreelancerAutoCompleteItem>;
  error: string | null;
  isLoading: boolean;
};

type UseUserFreelancersAutoCompleteInput = {
  query?: string;
};

const useUserFreelancersAutoComplete = (
  params: UseUserFreelancersAutoCompleteInput,
): UseUserFreelancersAutoCompleteHandler => {
  const { isLoading, error, data } = useQuery<
    Array<UserFreelancerAutoCompleteItem>,
    string
  >(['user-freelancers-auto-complete', params.query], async () => {
    const query: Record<string, string> = {};
    if (params.query) {
      query.q = params.query;
    }
    const response = await fetch(
      `/api/autocomplete/freelancers-users?${new URLSearchParams(query)}`,
    );
    if (response.ok) return response.json();
    throw new Error('Something went wrong');
  });
  return { data: data ?? [], error, isLoading };
};

export default useUserFreelancersAutoComplete;
